import { defineComponent as _defineComponent } from 'vue'
import { useVentureId } from '~/functions/accounts'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const ventureId = useVentureId()

return { __sfc: true,ventureId }
}

})